const FETCH_DATA = 'adebifyProductAnalysis/FETCH_DATA';
const FETCH_SUCCESS = 'adebifyProductAnalysis/FETCH_SUCCESS';
const FETCH_ERROR = 'adebifyProductAnalysis/FETCH_ERROR';
const SET_PARAMS = 'adebifyProductAnalysis/SET_PARAMS';
const CLEAN_STATE = 'adebifyProductAnalysis/CLEAN_STATE';
const DOWNLOAD_CSV = 'adebifyProductAnalysis/DOWNLOAD_CSV';

export default {
  FETCH_DATA,
  FETCH_SUCCESS,
  FETCH_ERROR,
  SET_PARAMS,
  CLEAN_STATE,
  DOWNLOAD_CSV,
};
